import { SMART_LINKS } from '@/constants/smartLinkConstants';
import { isIPhone } from '@/helpers/general';

/**
 * Hands the visitor over to the app: an iPhone tries the installed app first; every other device
 * goes through `/app?go=1`, which forwards Android phones to Google Play and leaves anything else
 * on the app landing page.
 */
export const openAppOrStore = (smartLink: string) => {
  if (isIPhone()) {
    SMART_LINKS.openIOSAppOrStore(smartLink);
    return;
  }

  window.location.href = SMART_LINKS.forceRedirectToStore(smartLink);
};
